var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 62,
      height: 62
    },
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6067,
    cy: 30.6067,
    r: 30.6067,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2791 33.0173V43.5692H27.4319V33.0173H23.405V28.7387H27.4319V27.182C27.4319 21.4026 29.8462 18.3638 34.9544 18.3638C36.5205 18.3638 36.912 18.6155 37.7695 18.8205V23.0525C36.8094 22.8847 36.5391 22.7915 35.5417 22.7915C34.3579 22.7915 33.724 23.1271 33.1461 23.7889C32.5681 24.4507 32.2791 25.5973 32.2791 27.2379V28.748H37.7695L36.2967 33.0266H32.2791V33.0173Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.447acc7513528da61e4a3d2dfa52ba70.svg";
export { ForwardRef as ReactComponent };